module.exports = __webpack_public_path__ + "assets/ffc295104c59e54e6ee00a5d129ee722.mp4";